import React, { useState } from 'react';
import { Box, Button, Typography } from '@heycater/design-system';
import { useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import ContactCatererForm from 'caterers/components/ContactCatererForm';
import BackgroundImage from 'shared/components/BackgroundImage';

const BookCateringCTA = ({ catererName, citySlug }) => {
  const mobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const { t } = useTranslation('caterers');
  const [openContactCatererForm, setOpenContactCatererForm] = useState(false);

  return (
    <StyledMainContainer mobile={mobile}>
      <BackgroundImage
        alt=""
        src="/artifacts/images/caterer/book_catering_cta_background.webp"
        layout="fill"
        objectFit="cover"
        objectPosition="center"
      />
      <StyledInnerContainer>
        <StyledCTAHeader variant="h5">
          {t('caterer.bookCateringHeader')}
        </StyledCTAHeader>
        <StyledCTAText>{t('caterer.bookCateringText')}</StyledCTAText>
        <Button
          size="lg"
          variant="primary"
          rounded
          onClick={() => setOpenContactCatererForm(true)}
        >
          {t('caterer.bookCateringButtonLabel')}
        </Button>
        <ContactCatererForm
          catererName={catererName}
          openContactCatererForm={openContactCatererForm}
          setOpenContactCatererForm={setOpenContactCatererForm}
          citySlug={citySlug}
        />
      </StyledInnerContainer>
    </StyledMainContainer>
  );
};

const StyledMainContainer = styled(Box)`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: ${(props) => props.theme.spacing(2)}px;
`;

const StyledInnerContainer = styled(Box)`
  display: flex;
  flex: 0.9;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${(props) => props.theme.spacing(2)}px;
  background: white;
  box-shadow: 0 4px 40px rgba(62, 41, 29, 0.08);
  border-radius: ${(props) => props.theme.spacing(1)}px;
`;

const StyledCTAHeader = styled(Typography)`
  margin-bottom: ${(props) => props.theme.spacing(1)}px;
`;

const StyledCTAText = styled(Typography)`
  margin-bottom: ${(props) => props.theme.spacing(2)}px;
`;

export default BookCateringCTA;
